import $$ from 'cmn-utils';

export async function qryFolderList(payload) {
  return $$.post('/folder/qryFolderList', payload);
}

export async function checkChildFolder(payload) {
  return $$.post('/folder/checkChildFolder', payload);
}

export async function qryFolderParentList(payload) {
  return $$.post('/folder/qryFolderParentList', payload);
}

export async function updateAuditStatus(payload) {
  return $$.post('/material/updateAuditStatus', payload);
}

export async function buildMaterialMenuTree(payload) {
  return $$.post('/folder/buildMaterialMenuTree', payload);
}


// WEBPACK FOOTER //
// ./src/routes/Material/Folder/service/index.js